import { minusSum, plusSum } from "./strings";

/**
 * Получить префикс для истории денег в филиале
 * @param {String} _type Тип операции с кассой филиала
 * @returns {String} (- || + || '')
 */
export function getFilialMoneyHistoryPrefix(_type) {
  switch (_type) {
    case "type_remove":
      return minusSum;
    case "type_to_sale":
      return minusSum;
    case "type_add":
      return plusSum;
    default:
      return "";
  }
}

/**
 * Получить префикс для истории денег в филиале
 * @param {String} _type Тип операции с кассой филиала
 * @returns {Object} {title: '', _id: '', document: 'bilets' || 'blanks'}
 */
export function getFilialMoneyStatusOperationWith(item) {
  const returnParams = {
    type: "",
    document: "",
    title: "",
    _id: ""
  };
  switch (item._options.type) {
    case "type_remove":
      returnParams.title = `Расходный к/о`;
      returnParams.document = "blanks";
      returnParams.type = "remove";
      break;
    case "type_to_sale":
      returnParams.title = `Списание з/б №${item._options.bilet.bilet_number}`;
      returnParams.document = "bilets";
      returnParams._id = item._options.bilet._id;
      returnParams.type = "remove";
      break;
    case "type_add":
      returnParams.title = `Приходный к/о`;
      returnParams.document = "blanks";
      returnParams.type = "add";
      break;
    default:
      break;
  }

  return returnParams;
}

/**
 * Получить условие в читаемом виде
 * @param {String} condition Условие
 * @returns {String} Меньше/Меньше или равно/Равно/Больше/Больше или равно
 */
export function getFilialPercentConditionString(condition) {
  switch (condition) {
    case "<":
      return "< Меньше";
    case "<=":
      return "≤ Меньше или равно";
    case "=":
      return "= Равно";
    case ">":
      return "> Больше";
    case ">=":
      return "≥ Больше или равно";
    default:
      return condition;
  }
}

/**
 * Получить источник условия в читаемом виде
 * @param {String} form Тип источника
 * @returns {String} Сумма/Дни
 */
export function getFilialPercentFormString(form) {
  switch (form) {
    case "sum":
      return "Сумма";
    case "day":
      return "Дни";
    default:
      return form;
  }
}
